class Actions {
    public static like(data: any) {
        // todo
    }
}

export default Actions;
